import {addFileToCache, getDataFromCache, manageCacheTime} from '../common/cache';
import {configApiDecathlonGo} from './config-api-decathlon-go';

export const checkAccountGo = (userId) => {

  let response = null;
  const config = configEnvironment();
  const route = 'decathlon_go';
  const url = `${config.domain}/${config.service}/${config.version}/${route}/${userId}`;

  jQuery.ajax({
    headers: {
      'user-id': userId,
      'x-api-key': config.apiKey
    },
    url,
    cache: true,
    async: false,
    dataType: 'json',
    success: (data) => {
      response = data.data;
    }
  });

  return response;
};


export const isUserPermitted = (userId) => {
  const cacheData = getDataFromCache('users-go');

  // eslint-disable-next-line no-nested-ternary
  let users = manageCacheTime('users-go') ? null : cacheData ? cacheData.users : null;

  if (window.location.origin.indexOf(':9000') >= 0 || window.location.origin.indexOf('slots-ux') >= 0) {
    if (!users) {
      // eslint-disable-next-line global-require
      const data = require('../static/json/users-go.json');
      users = data.users;
      addFileToCache('users-go', {conf: data, timestamp: new Date().getTime()});
    }
  } else if (!users) {
    jQuery.ajax({
      url: '/static/json/users-go.json',
      cache: true,
      async: false,
      dataType: 'json',
      success: (data) => {
        users = data.users;
        addFileToCache('users-go', {conf: data, timestamp: new Date().getTime()});
      }
    });
  }
  return users.includes(userId);
};

function configEnvironment() {

  return window.location.origin.includes('localhost') ? configApiDecathlonGo.local : configApiDecathlonGo[window.tc_vars.env_work];
}

export const checkProductsGo = (products) => {
  let response = null;
  const userId = window.tc_vars.user_id_1id;

  if (!isUserPermitted(userId)) return response;

  const config = configEnvironment();
  const route = 'decathlon_go_products';
  const params = `?products=${products.join(',')}`;
  const url = `${config.domain}/${config.service}/${config.version}/${route}${params}`;
  jQuery.ajax({
    headers: {
      'user-id': userId,
      'x-api-key': config.apiKey
    },
    url,
    cache: true,
    async: false,
    success: (data) => {
      response = data.data;
    }
  });
  return response;
};



// WEBPACK FOOTER //
// ./src/_override/api/go.js